















































































import {
  computed,
  defineComponent,
  reactive,
  Ref,
  ref,
  watch,
} from '@vue/composition-api';
import { useMutation, useQuery, useResult } from '@vue/apollo-composable';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import ProvinceAndDistrictSelector from '@/components/Setting/ProvinceAndDistrictSelector.vue';

import createAreaCode from '@/gql/areaCode/createAreaCode.gql';
import updateAreaCode from '@/gql/areaCode/updateAreaCode.gql';
import getAreaCode from '@/gql/areaCode/getAreaCode.gql';
import getHubs from '@/gql/company/getHubs.gql';

interface Location {
  id: -1;
  province?: { id: string };
  district?: { id: string };
}

const CommonFormWithAreaCodeEditor = defineComponent({
  components: {
    CommonModalWithPreset,
    ProvinceAndDistrictSelector,
  },
  props: {
    id: { default: -1 },
  },
  setup(props: any, { emit }: any) {
    const _areaCode = reactive({
      id: -1,
      code: '',
      name: '',
      location: [{
        id: -1,
        province: {
          id: '',
        },
        district: {
          id: '',
        },
      }],
      distanceType: '',
      hub: undefined,
    });
    const { result: areaCodeResult, loading } = useQuery(getAreaCode, computed(() => ({
      id: props.id,
    })));
    const areaCode = useResult(areaCodeResult, {}, (data) => data.area);
    watch(() => areaCodeResult.value, (newVal, oldVal) => {
      if (!loading.value && newVal !== oldVal) {
        _areaCode.id = areaCode.value.id;
        _areaCode.code = areaCode.value.code;
        _areaCode.name = areaCode.value.name;
        _areaCode.distanceType = areaCode.value.distanceType;
        _areaCode.location = areaCode.value.location.map((location: { id: number; province: { id: string }; district: { id: string } }) => ({
          ...location,
          id: location.id || -1,
        }));
        _areaCode.hub = areaCode.value.hub;
      } else {
        _areaCode.id = -1;
        _areaCode.code = '';
        _areaCode.name = '';
        _areaCode.distanceType = '';
        _areaCode.location = [{ id: -1, province: { id: '' }, district: { id: '' } }];
        _areaCode.hub = undefined;
      }
    });

    const deletedLocation: Ref<number[]> = ref([]);
    const updateLocationPayload = computed(() => {
      if (_areaCode.id === -1) {
        const create: any[] = [];
        (_areaCode.location as any).forEach((location: Location) => {
          create.push({ province: location.province?.id, district: location.district?.id });
        });

        return {
          create,
        };
      }
      const update: any[] = [];
      const upsert: any[] = [];
      (_areaCode.location as any).forEach((location: Location) => {
        if (location.id === -1) upsert.push({ province: location.province?.id, district: location.district?.id });
        else update.push({ id: location.id, province: location.province?.id, district: location.district?.id });
      });
      return {
        update,
        upsert,
        delete: deletedLocation.value,
      };
    });
    const areaCodeInput = computed(() => ({
      code: _areaCode.code,
      name: _areaCode.name,
      distanceType: _areaCode.distanceType,
      location: updateLocationPayload.value,
      hub: (_areaCode.hub as any)?.id ? {
        connect: (_areaCode.hub as any).id,
      } : undefined,
    }));
    function deleteLocationAction(location: Location, index: number) {
      if (location.id > -1) {
        deletedLocation.value.push(location.id);
      }
      _areaCode.location.splice(index, 1);
    }
    const refetchQueries = ['getAreaCodes', 'getAreaCode'];
    const createAreaCodeMutation = useMutation(createAreaCode, () => ({
      variables: {
        input: areaCodeInput.value,
      },
      refetchQueries,
    }));
    const updateAreaCodeMutation = useMutation(updateAreaCode, () => ({
      variables: {
        input: {
          id: _areaCode.id,
          ...areaCodeInput.value,
        },
      },
      refetchQueries,
    }));
    const confirmModal = ref(null);
    createAreaCodeMutation.onDone(() => {
      (confirmModal.value as any).compose({ action: 'บันทึก', entity: 'สำเร็จ' });
    });
    updateAreaCodeMutation.onDone(() => {
      emit('done');
      (confirmModal.value as any).compose({ action: 'บันทึก', entity: 'สำเร็จ' });
    });
    const errorModal = ref(null);
    createAreaCodeMutation.onError(() => {
      (errorModal.value as any).compose();
    });
    updateAreaCodeMutation.onError(() => {
      emit('error');
      (errorModal.value as any).compose();
    });

    const computedMutation = computed(() => {
      if (_areaCode.id !== -1) return updateAreaCodeMutation;
      return createAreaCodeMutation;
    });

    return {
      _areaCode,
      getHubs,
      updateLocationPayload,
      deleteLocationAction,

      confirmModal,
      errorModal,
      computedMutation,
    };
  },
});

export default CommonFormWithAreaCodeEditor;
